module.exports = __webpack_public_path__ + "static/img/movida.b61fb7a9.png";